import gql from "graphql-tag";

export const SUBSCRIBE_SAVEMETADATA = gql`
	subscription saveMetaData(
		$id: Int!
	) {
		saveMetaData(id: $id) {id}
	}
`;
